import React from "react";
import { 
  Utensils, 
  Car, 
  Fuel, 
  Home, 
  Heart, 
  Stethoscope, 
  GraduationCap, 
  Gamepad2, 
  Clapperboard, 
  Tv, 
  ShoppingCart, 
  ShoppingBag, 
  Banknote, 
  Wallet, 
  TrendingUp, 
  ChartPie, 
  Tag, 
  Star, 
  Zap, 
  Shield, 
  Gift,
  Briefcase,
  Plane,
  Smartphone,
  Wifi,
  Coffee,
  Dumbbell,
  Music,
  Book,
  Baby,
  PawPrint,
  Hammer,
  Bus,
  Train,
  CreditCard,
  DollarSign,
  Landmark,
  PiggyBank,
  AlertCircle
} from "lucide-react";

export type IconName = string;

export const CATEGORY_ICONS: Record<string, React.ElementType> = {
  "food": Utensils,
  "restaurant": Coffee,
  "car": Car,
  "fuel": Fuel,
  "bus": Bus,
  "train": Train,
  "home": Home,
  "utilities": Zap,
  "internet": Wifi,
  "phone": Smartphone,
  "health": Heart,
  "medical": Stethoscope,
  "fitness": Dumbbell,
  "education": GraduationCap,
  "books": Book,
  "entertainment": Gamepad2,
  "movies": Clapperboard,
  "tv": Tv,
  "music": Music,
  "shopping": ShoppingCart,
  "clothing": ShoppingBag,
  "salary": Banknote,
  "wallet": Wallet,
  "money": DollarSign,
  "investment": TrendingUp,
  "chart": ChartPie,
  "bank": Landmark,
  "savings": PiggyBank,
  "gift": Gift,
  "work": Briefcase,
  "travel": Plane,
  "kids": Baby,
  "pets": PawPrint,
  "services": Hammer,
  "insurance": Shield,
  "card": CreditCard,
  "star": Star,
  "alert": AlertCircle,
  "default": Tag,
};

export const AVAILABLE_ICONS = [
  { value: "food", label: "Alimentação", icon: Utensils },
  { value: "restaurant", label: "Restaurante/Café", icon: Coffee },
  { value: "car", label: "Carro", icon: Car },
  { value: "fuel", label: "Combustível", icon: Fuel },
  { value: "bus", label: "Ônibus", icon: Bus },
  { value: "train", label: "Trem/Metrô", icon: Train },
  { value: "travel", label: "Viagem", icon: Plane },
  { value: "home", label: "Casa", icon: Home },
  { value: "utilities", label: "Contas (Luz/Água)", icon: Zap },
  { value: "internet", label: "Internet", icon: Wifi },
  { value: "phone", label: "Telefone", icon: Smartphone },
  { value: "health", label: "Saúde", icon: Heart },
  { value: "medical", label: "Médico", icon: Stethoscope },
  { value: "fitness", label: "Academia/Esporte", icon: Dumbbell },
  { value: "education", label: "Educação", icon: GraduationCap },
  { value: "books", label: "Livros/Estudos", icon: Book },
  { value: "entertainment", label: "Lazer", icon: Gamepad2 },
  { value: "movies", label: "Cinema", icon: Clapperboard },
  { value: "tv", label: "Streaming/TV", icon: Tv },
  { value: "music", label: "Música", icon: Music },
  { value: "shopping", label: "Compras", icon: ShoppingCart },
  { value: "clothing", label: "Roupas", icon: ShoppingBag },
  { value: "salary", label: "Salário", icon: Banknote },
  { value: "work", label: "Trabalho/Freelance", icon: Briefcase },
  { value: "money", label: "Dinheiro", icon: DollarSign },
  { value: "wallet", label: "Carteira", icon: Wallet },
  { value: "investment", label: "Investimentos", icon: TrendingUp },
  { value: "bank", label: "Banco", icon: Landmark },
  { value: "savings", label: "Poupança", icon: PiggyBank },
  { value: "card", label: "Cartão", icon: CreditCard },
  { value: "insurance", label: "Seguro", icon: Shield },
  { value: "gift", label: "Presente", icon: Gift },
  { value: "kids", label: "Filhos", icon: Baby },
  { value: "pets", label: "Pets", icon: PawPrint },
  { value: "services", label: "Serviços/Manutenção", icon: Hammer },
  { value: "star", label: "Favorito", icon: Star },
  { value: "alert", label: "Alerta/Importante", icon: AlertCircle },
  { value: "default", label: "Outros", icon: Tag },
];

export function getCategoryIcon(iconName?: string | null): React.ElementType {
  if (!iconName || !CATEGORY_ICONS[iconName]) {
    return CATEGORY_ICONS["default"];
  }
  return CATEGORY_ICONS[iconName];
}
